// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aoGxO","label":"styles_label__33QFy"};